export default __webpack_public_path__ + "static/media/lounge.62e770ea.svg";